import { useChatMute } from '@components/Chat'
import React from 'react'
import { SectionDivider } from './EditTripModal.styles'
import SwitchRow from './SwitchRow'

interface ChatMuteSectionProps {
	/** Loads my mute while given; the modal passes it only while open. */
	tripId: string | undefined
}

/**
 * The Mute Chat notifications switch, for every member: a muted trip's Chat pushes me
 * only when someone tags me by name, and still counts my unread Messages. It flips at
 * once and auto-saves, apart from the form's Save and Cancel. iOS keeps it on Trip More.
 */
const ChatMuteSection: React.FC<ChatMuteSectionProps> = ({ tripId }) => {
	const { isMuted, isEnabled, setMuted } = useChatMute(tripId)

	return (
		<>
			<SectionDivider />
			<SwitchRow
				id="chat-mute"
				title="Mute Chat notifications"
				description="You'll still be notified when someone tags you."
				checked={isMuted}
				disabled={!isEnabled}
				onChange={() => setMuted(!isMuted)}
			/>
		</>
	)
}

export default ChatMuteSection
